module.exports = __webpack_public_path__ + "static/bg-box2-5b1a29acb0613e9325cc975c73ce3766.png";